export default {
    dark: "#0A0A0A",
    primary: "#afd2ff",
    secondary: "#A9E4EF",
    background: "#F4F5F7",
    green: "#a4db86",
    red: "#e64a4a",
}